module.exports = __webpack_public_path__ + "static/media/wbtc.4031ce47d66d6501010b568c2277a852.svg";